import { useShallow } from 'zustand/react/shallow';
import { useMemo } from 'react';
import isMatch from 'es-toolkit/compat/isMatch';
import { Breakpoints } from '@pkgs/components/providers/BreakpointProvider';

import { useSearchStore } from './useSearchStore';
import { extractStateFromStore } from './slices/utilSlice';
import { defaultRangesState } from './slices/rangesSlice';
import { defaultObjectTypeFilterState } from './slices/objectTypeFilterSlice';
import { defaultLocationState } from './slices/locationSlice';
import { defaultLifestyleCategoryState } from './slices/lifestyleCategorySlice';
import { defaultFeaturesState } from './slices/featuresSlice';
import { type SearchState } from './SearchStoreProvider';
import { useBreakpoint } from '../../useBreakpoint';

export const defaultAdvancedFiltersState: Partial<SearchState> = {
  ...defaultObjectTypeFilterState,
  ...defaultFeaturesState,
  ...defaultRangesState,
  ...defaultLifestyleCategoryState,
};

export function useAdvancedFiltersModified() {
  const { breakpoint = 0 } = useBreakpoint();

  const _defaultAdvancedFiltersState = useMemo<Partial<SearchState>>(
    () => ({
      ...defaultAdvancedFiltersState,
      ...(breakpoint < Breakpoints.TABLET_LANDSCAPE && { searchRadius: defaultLocationState.searchRadius }),
    }),
    [breakpoint],
  );

  const isModified = useSearchStore(useShallow((state) => !isMatch(extractStateFromStore(state), _defaultAdvancedFiltersState)));

  return { isModified };
}
